import { mapState, mapGetters, mapActions } from 'vuex';

/**
 * Mixin that provides location awareness to components
 *
 * This mixin makes it easy for components to:
 * 1. Access the currently selected location (customer ID)
 * 2. Check if multiple locations are available
 * 3. Get the name of the current location
 * 4. Get variables to use with GraphQL queries that need location context
 */
export default {
  computed: {
    ...mapState('locations', ['selectedCustomerId', 'customerFamily']),

    ...mapGetters('locations', [
      'hasMultipleLocations',
      'currentLocation',
      'locationName',
    ]),
  },

  methods: {
    ...mapActions('locations', ['selectLocation', 'fetchCustomerFamily']),

    /**
     * Returns variables object to use with location-specific GraphQL queries
     *
     * @returns {Object} Variables object with customerId
     */
    getLocationVariables() {
      return {
        customerId: this.selectedCustomerId,
      };
    },

    /**
     * Helper to determine if we should use location-specific queries
     * Only use location-specific queries if we have multiple locations
     *
     * @returns {Boolean} True if we should use location-specific queries
     */
    shouldUseLocationSpecificQueries() {
      return this.hasMultipleLocations && this.selectedCustomerId;
    },
  },
};
